import React, { memo } from "react"
import { graphql, useStaticQuery } from "gatsby"

import { FormButton } from "@app/components/Form/FormButton"

type Props = {
  handleToggle: () => void
}

export const ProductSizingToggle: React.FC<Props> = memo(({ handleToggle }) => {
  const { product } = useStaticQuery<GatsbyTypes.ProductSizingToggleQuery>(graphql`
    query ProductSizingToggle {
      product: sanityTemplateProduct {
        additionalSizing
      }
    }
  `)

  return (
    <FormButton
      noRotate
      color="grey.text"
      onClick={handleToggle}
      size="ghost"
      fontSize="sm"
      textDecoration="underline"
      title={product?.additionalSizing}
      aria-label={product?.additionalSizing}
      variant="ghost"
    >
      {product?.additionalSizing}
    </FormButton>
  )
})
